<template>
  <v-app-bar color="#006064" dark>
    <v-toolbar-title title-header class="display-2 white--text">
      <router-link to="/">
        <h1 class="display-2">Nutris</h1>
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu left bottom v-if="isAuth">
      <template v-slot:activator="{ on }">
        <v-list-item-avatar class="mr-0" v-on="on">
          <img :src="profile.photo" :alt="profile.name" />
        </v-list-item-avatar>
      </template>

      <v-list>
        <v-list-item v-if="getDiets.length > 0" @click="changeRoute('calcular-dieta')">
          <v-list-item-title>Bora calcular</v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeRoute('gerenciar-dietas')">
          <v-list-item-title>Gerenciar dietas</v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeRoute('historico')">
          <v-list-item-title>Histórico</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isAuth" @click="logout()">
          <v-list-item-title>sair</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import firebase from "firebase";
export default {
  name: "appHeader",
  computed: {
    isAuth() {
      return this.$store.getters["auth/userId"];
    },
    profile() {
      return this.$store.getters["auth/profile"];
    },
    getDiets() {
      return this.$store.getters["dietsBase/getDiets"];
    }
  },
  methods: {
    changeRoute(route) {
      this.$router.replace(route);
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          let user = firebase.auth().currentUser;
          this.$store.commit("auth/setUser", user);
          this.changeRoute("/");
        });
    }
  }
};
</script>

<style scoped>
[title-header] > a {
  cursor: pointer;
  transform: none;
  color: white;
  text-decoration: none;
  font-family: "Roboto";
}

.v-menu__content {
  top: 5px !important;
}

h1 {
  font-family: "Lobster", cursive;
  font-size: 1.8em;
}
</style>
